import { ClassName, SlugType } from "@/helpers/pageHelpers/Common/interface";
import {
  IconButtonSizes,
  IconButtonTypes,
} from "@/components/IconButton/IconButton.interface";

export interface FollowAuthorButtonInteface {
  followed: boolean;
  slug: SlugType;
  className?: ClassName;
  variant?: IconButtonTypes;
  size?: IconButtonSizes;
}

export enum CheckboxEnum {
  AddConfirmation = "addConfirmation",
  RemoveConfirmation = "removeConfirmation",
}
